import type { CcLandingConfig, environments } from "./types";

// The nonprod OEM compliance element. Local development points at the same np artifact: the
// bundle carries its own environment, so there is no local build of it to serve.
const OEM_COMPLIANCE_LOADER_URL_NP =
  "https://extractor.np.oem-agentic-platform.web-np.dealer.com/load.js";

export const ccLandingConfig: Record<environments, CcLandingConfig> = {
  local: {
    launchDarklyKey: "644841c41384731244c27357",
    gtmAccountId: "GTM-5DL26DD",
    newRelic: {
      accountID: "1759997",
      trustKey: "1190893",
      agentID: "1134327616",
      licenseKey: "319ccf429e",
      applicationID: "1134327616"
    },
    pendo: {
      apiKey: "53e0835b-8f53-4c01-45c0-e277be49f4d5"
    },
    oemComplianceLoaderUrl: OEM_COMPLIANCE_LOADER_URL_NP
  },
  qa: {
    launchDarklyKey: "644841c41384731244c27357",
    gtmAccountId: "GTM-5DL26DD",
    newRelic: {
      accountID: "1759997",
      trustKey: "1190893",
      agentID: "1134327616",
      licenseKey: "319ccf429e",
      applicationID: "1134327616"
    },
    pendo: {
      apiKey: "53e0835b-8f53-4c01-45c0-e277be49f4d5"
    },
    oemComplianceLoaderUrl: OEM_COMPLIANCE_LOADER_URL_NP
  },
  prod: {
    launchDarklyKey: "644841c41384731244c27358",
    gtmAccountId: "GTM-5DL26DD",
    newRelic: {
      accountID: "1759997",
      trustKey: "1190893",
      agentID: "1134511612",
      licenseKey: "319ccf429e",
      applicationID: "1134511612"
    },
    pendo: {
      apiKey: "53e0835b-8f53-4c01-45c0-e277be49f4d5"
    },
    // No production OEM host exists yet: site-intelligence-ui publishes one bundle per
    // environment and has no `prod` row, so there is nothing to point at. Empty keeps the
    // page's unavailable state honest; the LaunchDarkly flag stays off in prod regardless.
    oemComplianceLoaderUrl: ""
  }
};
